import React from 'react';
import { Helmet } from 'react-helmet-async';

const SITE_URL = process.env.REACT_APP_SITE_URL || 'https://stallionbulktech.com';
const OG_IMAGE =
  'https://customer-assets.emergentagent.com/job_add4c97a-cab7-4cb4-a1cf-0b5112bb0652/artifacts/zur5e9w0_Stallion%20Bulktech.png';

/**
 * Per-page SEO metadata: title, description, canonical, Open Graph, Twitter Card,
 * and optional JSON-LD structured data.
 */
const SEO = ({ title, description, path = '/', image = OG_IMAGE, jsonLd }) => {
  const url = `${SITE_URL}${path}`;
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />

      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="Stallion Bulktech" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {jsonLd && (
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      )}
    </Helmet>
  );
};

export default SEO;
